export default "__VITE_ASSET__7e08d8ad__"